<script lang="ts" setup>
import { TimeFieldInput, TimeFieldRoot, TimeValue } from 'reka-ui';
import { useUUID } from '../../../helpers/form-field.js';
import { Time } from '@internationalized/date';

defineProps<{
  label: string;
  placeholder: string;
}>();

defineModel<Date>();

const randomId = useUUID();

function convertDateToTimeValue(date?: Date): TimeValue | undefined {
  if (!date) {
    return undefined;
  }
  const time = new Time(date?.getHours(), date?.getMinutes());

  return time;
}
</script>

<template>
  <y-input-wrapper>
    <label slot="label" :for="randomId">{{ label }}</label>

    <TimeFieldRoot locale="nl" :id="randomId" v-slot="{ segments }" :model-value="convertDateToTimeValue(modelValue)"
      required class="time__field order-form__input-text" @update:model-value="(val) => {
        const now = new Date();

        if (val) {
          now.setHours(val.hour);
          now.setMinutes(val.minute);
        }

        $emit('update:modelValue', now)

      }">
      <template v-for="item in segments" :key="item.part">
        <TimeFieldInput v-if="item.part === 'literal'" :part="item.part"
          class="time__field__input time__field__input--literal">
          {{ item.value }}
        </TimeFieldInput>
        <TimeFieldInput v-else :part="item.part" class="time__field__input time__field__input--value">
          {{ item.value }}
        </TimeFieldInput>
      </template>

    </TimeFieldRoot>
  </y-input-wrapper>
</template>
